import { IconProps } from "@tfg/ui"

type Props = IconProps

export const IconFootwearAssembling = ({ size = 24, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 25"
    fill="none"
    {...props}
  >
    <path
      d="M30 22.8098V20.2774L2 20C2 21.8621 7.42169 23 11.3494 23H29.8098C29.9148 23 30 22.9148 30 22.8098Z"
      stroke="black"
      strokeWidth="2.02301"
    />
    <path
      d="M17.1464 18.3536C17.3417 18.5488 17.6583 18.5488 17.8536 18.3536L21.0355 15.1716C21.2308 14.9763 21.2308 14.6597 21.0355 14.4645C20.8403 14.2692 20.5237 14.2692 20.3284 14.4645L17.5 17.2929L14.6716 14.4645C14.4763 14.2692 14.1597 14.2692 13.9645 14.4645C13.7692 14.6597 13.7692 14.9763 13.9645 15.1716L17.1464 18.3536ZM18 13.5C18 13.2239 17.7761 13 17.5 13C17.2239 13 17 13.2239 17 13.5H18ZM18 18V13.5H17V18H18Z"
      fill="black"
    />
    <path
      d="M29.9801 5.44336C26.101 5.44336 23.75 9.20486 23.75 11.2032"
      stroke="black"
      strokeWidth="1.99999"
    />
    <path
      d="M28.4484 11.0855C29.3888 11.0855 29.9765 10.3567 29.9765 9.74548L29.9969 2.57821C29.9986 1.97975 29.5139 1.4937 28.9155 1.4937H28.2368C27.9771 1.4937 27.7666 1.70412 27.7666 1.9638V3.06882C27.7666 4.38535 23.1816 3.76293 21.8886 3.76293C21.2272 3.10159 20.6327 2.08439 19.7059 1.12293C19.63 1.04414 19.5235 1.00325 19.4145 1.01324C15.3569 1.38499 10.4632 5.84847 5.43241 6.24259C5.38539 6.24259 2 6.54821 2 9.29881C2 12.6136 27.508 11.0855 28.4484 11.0855Z"
      stroke="black"
      strokeWidth="1.99999"
    />
    <path
      d="M16.4968 4.95747C16.7865 5.42766 17.4025 5.57397 17.8727 5.28425C18.3429 4.99453 18.4892 4.37851 18.1995 3.90832L16.4968 4.95747ZM15.0627 2.63005L16.4968 4.95747L18.1995 3.90832L16.7654 1.58089L15.0627 2.63005Z"
      fill="black"
    />
    <path
      d="M14.2702 5.96724C14.56 6.43743 15.176 6.58373 15.6462 6.29402C16.1164 6.0043 16.2627 5.38827 15.9729 4.91808L14.2702 5.96724ZM12.8361 3.63981L14.2702 5.96724L15.9729 4.91808L14.5389 2.59066L12.8361 3.63981Z"
      fill="black"
    />
    <path
      d="M12.0676 6.67276C12.3439 7.15096 12.9555 7.31464 13.4337 7.03834C13.9119 6.76204 14.0756 6.1504 13.7993 5.6722L12.0676 6.67276ZM10.8451 4.55692L12.0676 6.67276L13.7993 5.6722L12.5768 3.55636L10.8451 4.55692Z"
      fill="black"
    />
  </svg>
)
